module.exports = __webpack_public_path__ + "static/media/abacaxi2.a6bfe1da.png";